if (!customElements.get("video-ctl-wrapper")) {
  customElements.define(
    "video-ctl-wrapper",
    class VideoCtlWrapper extends HTMLElement {
      constructor() {
        super();
        this.isPlaying = false;
        this.isVideoReady = false;
        console.log("video-ctl-wrapper");
      }

      videoElement = null;
      btnElement = null;
      playIcon = null;
      pauseIcon = null;
      loadingOverlay = null;
      isPlaying = false;
      isVideoReady = false;

      connectedCallback() {
        this.videoElement = this.querySelector("video");
        this.btnElement = this.querySelector(".data-video-btn");
        this.playIcon = this.querySelector("[data-play-icon]");
        this.pauseIcon = this.querySelector("[data-pause-icon]");
        this.loadingOverlay = this.querySelector("[data-loading-overlay]");

        console.log("on connectedCallback", this.btnElement, this.videoElement);

        if (!this.videoElement || !this.btnElement) {
          console.error("Video element or button not found", {
            videoElement: this.videoElement,
            btnElement: this.btnElement,
          });
          return;
        }

        // 监听视频加载状态
        this.videoElement.addEventListener("canplay", () => this.handleCanPlay());
        this.videoElement.addEventListener("loadeddata", () => this.handleLoadedData());

        this.btnElement.addEventListener("click", () => this.togglePlay());
        this.videoElement.addEventListener("ended", () => this.handleEnded());
        this.videoElement.addEventListener("pause", () => this.handlePause());
        this.videoElement.addEventListener("play", () => this.handlePlay());

        // 检查视频是否已经加载
        if (this.videoElement.readyState >= 3) {
          this.isVideoReady = true;
        }
      }

      handleCanPlay() {
        this.isVideoReady = true;
        this.hideLoading();
        console.log("Video can play");
      }

      handleLoadedData() {
        this.isVideoReady = true;
        this.hideLoading();
        console.log("Video loaded data");
      }

      togglePlay() {
        if (this.isPlaying) {
          this.videoElement.pause();
        } else {
          // 如果视频未准备好，显示 loading
          if (!this.isVideoReady) {
            this.showLoading();
          }
          
          this.videoElement.play().catch((error) => {
            console.error("Play failed:", error);
            this.hideLoading();
          });
        }
      }

      handleEnded() {
        this.isPlaying = false;
        this.updateIcons();
        this.hideLoading();
      }

      handlePause() {
        this.isPlaying = false;
        this.updateIcons();
        this.hideLoading();
      }

      handlePlay() {
        this.isPlaying = true;
        this.updateIcons();
      }

      showLoading() {
        if (this.loadingOverlay) {
          this.loadingOverlay.classList.remove("hidden");
        }
      }

      hideLoading() {
        if (this.loadingOverlay) {
          this.loadingOverlay.classList.add("hidden");
        }
      }

      updateIcons() {
        if (this.isPlaying) {
          this.playIcon.classList.add("hidden");
          this.pauseIcon.classList.remove("hidden");
        } else {
          this.playIcon.classList.remove("hidden");
          this.pauseIcon.classList.add("hidden");
        }
      }
    },
  );
}
